import styles from "@/components/settings-item.module.css";
import { SettingsItemInfo } from "@/types";
import { ChangeEvent, JSX, useId } from "react";

interface SettingsItemProps {
	item: SettingsItemInfo;
	onChange: (
		event: ChangeEvent<HTMLInputElement | HTMLSelectElement>,
	) => void;
}

function SettingsItem({ item, onChange }: SettingsItemProps): JSX.Element {
	const id = useId();

	const optionElements = (item.options || []).map((option) => {
		const disabled = typeof option === "object" && option.when === false;
		const text = typeof option === "string" ? option : option.text;
		const value = typeof option === "string" ? option : option.value;

		return (
			<option
				disabled={disabled}
				key={value}
				value={value}
			>
				{text}
			</option>
		);
	});

	return (
		<div className={styles["settings-item"]}>
			<label htmlFor={id}>{item.label}</label>
			{item.options ? (
				<select
					id={id}
					value={String(item.default)}
					onChange={onChange}
				>
					{optionElements}
				</select>
			) : (
				<input
					id={id}
					className={styles["input-box"]}
					value={String(item.default)}
					onChange={onChange}
				/>
			)}
		</div>
	);
}

export default SettingsItem;
